/**
 *
 *  PasswordInput
 *  Component
 *
 *  Created by Vladimir Shishlyannikov on 14/06/2023.
 *  Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 *
 */

import React, { useCallback, useState, ChangeEvent } from 'react';
import PropTypes from 'prop-types';

import { Theme } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';

// Icons
import PasswordHideIcon from '../../icons/PasswordHideIcon';
import PasswordShowIcon from '../../icons/PasswordShowIcon';

// onKeyDown: (event: KeyboardEvent<HTMLInputElement>, index: number) => void;
// onInput: (event: KeyboardEvent<HTMLInputElement>, index: number) => void;

import { makeStyles } from '@material-ui/core/styles';
// import { useLocation, useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme: Theme) => ({
  // googleButton: {
  //   background: 'white',
  //   color: 'rgb(0, 94, 166)',
  //   'border-radius': '4px',
  //   border: '2px solid rgb(2, 122, 197)',
  //   margin: '1.8em 0 0.7em',
  //   'text-transform': 'none',
  //   'box-shadow': 'none',
  //   padding: '0.3em 1em',
  //   [theme.breakpoints.down('sm')]: {
  //     width: '100%',
  //   },
  //   '&:hover': {
  //     background: 'white',
  //     'box-shadow': 'none',
  //   },
  // },
  // errorMessage: {
  //   color: 'red',
  //   display: 'flex',
  //   'align-items': 'center',
  //   margin: '1em 0 0.2em',
  //   '& svg': {
  //     'margin-right': '0.4em',
  //   },
  // },
  // container: {
  //   'margin-top': '80px', //'2.5em',
  //   padding: '24px',
  //   // height: '100%',
  //   // 'margin-bottom': '2.5em',
  // },
  // partnerLabelContainer: {
  //   position: 'relative',
  //   display: 'flex',
  //   'align-items': 'center',
  //   'justify-content': 'center',
  //   'margin-bottom': '52px',
  //   // 'background-image': Partner,
  //   'background-size': '100%',
  //   'background-repeat': 'no-repeat',
  //   width: '107px',
  //   height: '36px',
  //   [theme.breakpoints.down('sm')]: {
  //     // width: '100%',
  //     // height: '100px',
  //     // backgroundPositionY: '140px',
  //   },
  // },
  // trubeLogo: {
  //   // position: 'absolute',
  //   // top: 0,
  //   // left: '0',
  //   'margin-bottom': '10px',
  // },
  // passwordContainer: {
  //   // 'min-height': '120px',
  //   'margin-bottom': '24px',
  // },
  inputField: {
    position: 'relative',
  },
  passwordToggle: {
    position: 'absolute',
    bottom: '16px',
    top: '12px',
    right: '12px',
    // tbk-text-coral
  },

  // closeBackgroundSelection: {
  //   cursor: 'pointer',
  //   display: 'flex',
  //   background: 'transparent',
  //   border: '0',
  //   padding: '0',
  // },
}));

interface PasswordInputProps {
  hasError?: boolean;
  autoComplete: string;
  placeholder: string;
  minLength: number;
  maxLength: number;
  pattern: string;
  password: string; // value
  style?: any;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

type Ref = HTMLInputElement;

export const PasswordInput = React.forwardRef<Ref, PasswordInputProps>(
  (
    {
      hasError,
      autoComplete = 'current-password',
      placeholder,
      minLength,
      maxLength,
      pattern,
      password,
      style,
      onChange,
      ...rest
    },
    outerRef
  ) => {
    const classes = useStyles();

    const [showPassword, setShowPassword] = useState(false);

    const handlePasswordToggle = useCallback(
      e => {
        if (showPassword) {
          setShowPassword(false);
        } else {
          setShowPassword(true);
        }
      },
      [showPassword]
    );

    return (
      <div
        className={classes.inputField}
        // className={`tbk-input-field tbk-relative tbk-py-0 tbk-pl-0 focus-within:tbk-border-blue-grey ${
        //   hasError ? "tbk-border-coral" : ""
        // }`}
      >
        {/*        <input
          // @ts-ignore
          ref={outerRef}
          type={showPassword ? "text" : "password"}
          className="tbk-text-main tbk-w-full tbk-rounded-lg tbk-pt-[11px] tbk-pl-2 tbk-pr-2 tbk-pb-[11px] tbk-outline-none"
          autoComplete={autoComplete}
          placeholder={placeholder}
          minLength={minLength}
          maxLength={maxLength}
          pattern={pattern}
          style={style}
          value={password}
          onChange={onChange}
          onInput={onChange}
        />*/}
        <TextField
          // @ts-ignore
          ref={outerRef}
          // id="input-email"
          // onChange={(e: ChangeEvent<HTMLInputElement>) => setPhoneNumber(e.target.value)}
          type={showPassword ? 'text' : 'password'}
          autoComplete={autoComplete}
          placeholder={placeholder}
          InputProps={{ disableUnderline: true }}
          // minLength={minLength}
          // maxLength={maxLength}
          // pattern={pattern}
          style={style}
          value={password}
          onChange={onChange}
          onInput={onChange}
        />

        <div
          role="button"
          tabIndex={-1}
          className={classes.passwordToggle}
          // className="tbk-absolute tbk-bottom-2 tbk-top-1.5 tbk-right-1.5 tbk-text-coral"
          onClick={handlePasswordToggle}
        >
          {showPassword ? <PasswordHideIcon /> : <PasswordShowIcon />}
        </div>
      </div>
    );
  }
);

export default PasswordInput;
